import MapLocationDetail from './MapLocationDetail';

export default MapLocationDetail;
